module.exports = __webpack_public_path__ + "static/img/yodobashi_s.3bdc6c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ribenurl/yodobashi_s.jpg
// module id = 70HH
// module chunks = 23